const CalculationsSum = (data) => {
  return data.reduce((a, b) => Number(a) + Number(b), 0);
}

export default CalculationsSum;
